import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { CustomCustomerField, getCustomCustomerFieldTypeDisplay } from '../../../../../../models/organization-config';
import { CallbackResult, CallbackResultStatus } from '../../../../../../utils';
import { OrganizationConfigService } from '../../../../../../services/organization-config/organization-config.service';
import { AccountService } from '../../../../../../services/account/account.service';
import { SimpleMessageModalComponent } from '../../../../../../components/modals/simple-message-modal/simple-message-modal.component';
import { AddCustomCustomerFieldModalComponent } from './modals/add-custom-customer-field-modal/add-custom-customer-field-modal.component';
import {
  EditCustomCustomerFieldModalComponent
} from './modals/edit-custom-customer-field-modal/edit-custom-customer-field-modal.component';


@Component({
  selector: 'app-custom-customer-fields-config',
  templateUrl: './custom-customer-fields-config.component.html',
  styleUrls: ['./custom-customer-fields-config.component.css']
})
export class CustomCustomerFieldsConfigComponent implements OnInit {
  public fields: CustomCustomerField[] = [];

  public loadingFields = true;
  public loadingEdit = false;

  public serverError: number = null;

  public callbackResult: CallbackResult = null;

  // Create instance references to lookup functions and enums so they may be
  // called in the template.
  public CallbackResultStatus = CallbackResultStatus;
  public getCustomCustomerFieldTypeDisplay = getCustomCustomerFieldTypeDisplay;

  constructor(
    private accountService: AccountService,
    private orgConfigService: OrganizationConfigService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.loadFields();
  }

  public openEditFieldModal(field: CustomCustomerField) {
    // Create a copy so that the info is only updated in the table after it is
    // saved to the API.
    const fieldInput: CustomCustomerField = {...field};

    this.callbackResult = null;

    const modalRef = this.modalService.open(EditCustomCustomerFieldModalComponent);
    modalRef.componentInstance.field = fieldInput;
    modalRef.componentInstance.savedCallback = (result: CallbackResult) => {
      this.callbackResult = result;
      this.loadFields();
    };}

  public openRemoveFieldModal(field: CustomCustomerField) {
    this.callbackResult = null;

    const modalRef = this.modalService.open(SimpleMessageModalComponent);
    modalRef.componentInstance.headerText = 'Remove Custom Field';
    if (field.name && field.name !== '') {
      modalRef.componentInstance.messageText = 'Are you sure you want to remove "' + field.name + '"? This action cannot be undone.';
    } else {
      modalRef.componentInstance.messageText = 'Are you sure you want to remove this custom field? This action cannot be undone.';
    }
    modalRef.componentInstance.messageAlertClass = 'alert-danger';
    modalRef.componentInstance.hasConfirmation = true;
    modalRef.componentInstance.confirmedCallback = () => {
      this.loadingEdit = true;

      this.orgConfigService
        .deleteCustomCustomerField(field.url)
        .then(() => {
          this.callbackResult = {
            text: 'Custom field removed successfully.',
            status: CallbackResultStatus.success
          };
        })
        .catch(reason => {
          if (reason.status === 403) {
            this.callbackResult = {
              text: 'You do not have permission to remove this custom field.',
              status: CallbackResultStatus.error
            };
          } else if (reason.status === 404) {
            this.callbackResult = {
              text: 'This custom field could not be found. It may have already been removed.',
              status: CallbackResultStatus.error
            };
          } else {
            this.serverError = reason.status;
          }
        })
        .finally(() => {
          this.loadingEdit = false;
          this.loadFields();
        });
    };
  }

  public openAddFieldModal() {
    this.callbackResult = null;

    const modalRef = this.modalService.open(AddCustomCustomerFieldModalComponent);
    modalRef.componentInstance.savedCallback = (result: CallbackResult) => {
      this.callbackResult = result;
      this.loadFields();
    };
  }

  private loadFields() {
    this.loadingFields = true;

    this.orgConfigService
      .getCustomCustomerFields(1, 3000)
      .then(response => { this.fields = response.results; })
      .catch(reason => {
        if (reason.status === 403) {
          this.accountService.logout();
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingFields = false; });
  }
}
